import ProblemHackingContainer from './problem_hacking_container';

const ProblemHacking = ProblemHackingContainer;
export default ProblemHacking;
